module.exports = __webpack_public_path__ + "media/images/pc/specials/common/special_c_04-6baa82696166fbfe2772dff7064c7c0e.png";